import { NgModule } from 'ng-metadata/core';
import './card-grid-list.scss';

/**
 * @ngdoc module
 * @name mw.components.cardGridList
 * @description
 *
 * Card Grid List
 */
@NgModule({})
export class CardGridListModule {}



// WEBPACK FOOTER //
// ./src/lib/components/card-grid-list/card-grid-list.module.ts